import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../config/msalConfig';
import authService from '../services/authService';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    
    setIsLoggingIn(true);
    setError(null);
    
    try {
      console.log('Initiating Microsoft SSO login...');
      
      // Login with Microsoft using popup
      const loginResponse = await instance.loginPopup(loginRequest);
      console.log('Microsoft login successful:', loginResponse);
      
      // Get the access token
      const accessToken = loginResponse.accessToken;
      
      // Send the access token to backend for validation and JWT generation
      console.log('Sending access token to backend...');
      const backendResponse = await authService.loginWithMicrosoft(accessToken);
      
      console.log('Backend authentication successful:', backendResponse);
      
      // Reset loading state before navigation
      setIsLoggingIn(false);
      
      // Navigate to home page
      navigate('/home');
      
    } catch (error: any) {
      console.error('Login error:', error);
      setError(error.message || 'Failed to process user authentication');
      setIsLoggingIn(false);
    }
  };

  return (
    <div id="loginPage" className="login-page">
      {/* Full Screen Banner Background */}
      <div className="login-background"></div>
      
      {/* Gradient Overlay */}
      <div className="login-overlay"></div>
      
      {/* Login Modal */}
      <div className="login-container">
        <div className="login-modal">
          {/* JWIL Logo and Title */}
          <div className="login-header">
            <img src="/assets/images/jwil-logo.svg" alt="JWIL Logo" className="logo-image" />
          </div>
          
          {/* Welcome Text */}
          <div className="welcome-section">
            <h1 className="welcome-title">Welcome To JWIL Intranet Portal</h1>
            <p className="welcome-description">Please use existing Microsoft Office 365 credentials for Login to Intranet Portal</p>
          </div>
          
          {/* Error Message */}
          {error && (
            <div style={{
              backgroundColor: '#fee',
              color: '#c33',
              padding: '10px',
              borderRadius: '5px',
              marginBottom: '15px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}
          
          {/* Login Button */}
          <button 
            id="loginButton" 
            className="login-button" 
            onClick={handleLogin}
            type="button"
            disabled={isLoggingIn}
            style={{
              cursor: isLoggingIn ? 'not-allowed' : 'pointer',
              pointerEvents: 'auto',
              opacity: isLoggingIn ? 0.6 : 1
            }}
          >
            <img src="/assets/images/office-icon.svg" alt="Office Icon" />
            {isLoggingIn ? 'Logging in...' : 'Login'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
